import React from "react";
import { Dialog, Classes } from "@blueprintjs/core";
import {useTranslation} from "react-i18next";

// Libs
import {primaryColor} from "../common/libs/theme-lib";

// Components
import Button from "../common/components/button";

const ServiceConditionsDialog = (props) => {
    const {isOpen, onClose} = props;

    // i18n
    const {t} = useTranslation("welcome");

    return (
        <Dialog
            isOpen={isOpen}
            onClose={onClose}
            lazy={true}
            style={{
                backgroundColor: "white",
                paddingBottom: "40px",
                width: 1000,
                maxWidth: "100%"
            }}
        >
            <div
                style={{margin: "20px 40px"}}
                className={Classes.DIALOG_BODY}
            >
                <h3 style={{margin: "20px 0"}}>{t("serviceConditions.title")}</h3>
                <p><b>{t("serviceConditions.subtitle0")}</b></p>
                <p>{t("serviceConditions.text0")}</p>
                <p>{t("serviceConditions.text1")} <b>{t("serviceConditions.privacyPolicy")}</b></p>
                <p>{t("serviceConditions.text2")}</p>
                <p>{t("serviceConditions.text3")}</p>
                <p><b>{t("serviceConditions.subtitle1")}</b></p>
                <p>{t("serviceConditions.text4")}</p>
                <ul>
                    <li>
                        <p>{t("serviceConditions.li0")}</p>
                    </li>
                    <li>
                        <p>{t("serviceConditions.li1")}</p>
                    </li>
                    <li>
                        <p>{t("serviceConditions.li2")}</p>
                    </li>
                    <li>
                        <p>{t("serviceConditions.li3")}</p>
                    </li>
                </ul>
                <p>{t("serviceConditions.text5")}</p>
                <p><b>{t("serviceConditions.subtitle2")}</b></p>
                <p>{t("serviceConditions.text6")}</p>
                <p>{t("serviceConditions.text7")}</p>
                <p><b>{t("serviceConditions.subtitle3")}</b></p>
                <p>{t("serviceConditions.text8")} <a style={{fontWeight: "bolder", color: primaryColor, textDecoration: "underline"}} href={"mailto:" + t("serviceConditions.email")}>{t("serviceConditions.email")}</a> {t("serviceConditions.text9")}</p>
                <p>{t("serviceConditions.text10")}</p>
            </div>
            <div
                style={{margin: "20px 40px 0 40px"}}
                className={Classes.DIALOG_FOOTER}
            >
                <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                    <Button
                        text={t("serviceConditions.closeDialog")}
                        action={() => onClose()}
                        intent={"cancel"}
                    />
                </div>
            </div>
        </Dialog>
    );
}

export default ServiceConditionsDialog;